import { Link } from 'react-router-dom';
import { articles } from '@/mocks/siteData';

export default function FeaturedArticles() {
  const featured = articles.filter((a) => a.featured).slice(0, 3);

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              精选推荐
            </h2>
            <p className="text-foreground-600">编辑精选优质内容，不容错过</p>
          </div>
          <Link
            to="/category/zuixin-zixun"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full">
                    精选
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2 mb-4">{article.excerpt}</p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{article.date}</span>
                  <span>{article.readTime} 阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <Link
          to="/category/zuixin-zixun"
          className="sm:hidden mt-6 flex items-center justify-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-200"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}